import { useState, useEffect, useCallback } from 'react';

const DISCOVER_BADGE_KEY = 'discover_badge_shown';

const useDiscoverBadge = () => {
  const [showBadge, setShowBadge] = useState(false);

  useEffect(() => {
    const hasSeenDiscover = localStorage.getItem(DISCOVER_BADGE_KEY);
    setShowBadge(!hasSeenDiscover);
  }, []);

  const hideBadge = useCallback(() => {
    localStorage.setItem(DISCOVER_BADGE_KEY, 'true');
    setShowBadge(false);
    window.dispatchEvent(new CustomEvent('discoverBadgeHidden'));
  }, []);

  useEffect(() => {
    const handleBadgeHidden = () => setShowBadge(false);
    window.addEventListener('discoverBadgeHidden', handleBadgeHidden);
    return () => window.removeEventListener('discoverBadgeHidden', handleBadgeHidden);
  }, []);

  return {
    showBadge,
    hideBadge,
    badgeCount: showBadge ? 45 : 0,
  };
};

export default useDiscoverBadge;
